import { Component, OnInit, Input } from '@angular/core';
import { FlexBaseComponent } from '@wephone-core-ui';
import { _tk, _ti } from '@wephone-translation';
import { SipTrunkEntity } from '@wephone-core/model/entity/siptrunk';
import { SipTrunkRepository } from '@wephone-core/model/repository/siptrunk';
import { SipTrunkService } from '@wephone/services/siptrunk.service';
import { SipTrunkConnectionLogEntity } from '@wephone-core/model/entity/siptrunk_connection_log';

@Component({
  selector: 'app-siptrunk-connection-log',
  templateUrl: './siptrunk-connection-log.component.html',
  styleUrls: ['./siptrunk-connection-log.component.scss']
})
export class SipTrunkConnectionLogComponent extends FlexBaseComponent implements OnInit {
  @Input() siptrunk: SipTrunkEntity;
  siptrunkRepo: SipTrunkRepository = SipTrunkRepository.getInstance<SipTrunkRepository>();
  siptrunkConnectionLogs: SipTrunkConnectionLogEntity[] = [];

  constructor(
    private readonly siptrunkService: SipTrunkService,
  ) {
    super();
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

  }

  protected async resolveData(): Promise<void> {
    this.siptrunkConnectionLogs = await this.siptrunkService.getSipTrunkConnectionLog(this.siptrunk.id, 10);
  }
}
